module.exports = __webpack_public_path__ + "static/kucharka-62d421c70a8b06f6f53fa51c0001b0b5.png";